export interface CurrentSessionRouteContext {
  path: string
  isNewChat: boolean
  routeSessionId: string
  hasExplicitCardTarget: boolean
}

export const shouldReconcileCurrentSession = (context: CurrentSessionRouteContext) =>
  context.path === '/chat' &&
  !context.isNewChat &&
  !context.routeSessionId &&
  !context.hasExplicitCardTarget

export const resolveCurrentSessionAction = (context: {
  localSessionId: string
  currentSessionId: string
  created: boolean
  messageCount: number
}) => {
  if (context.created) return 'created' as const
  if (context.localSessionId === context.currentSessionId && context.messageCount > 0) {
    return 'retained' as const
  }
  return 'load' as const
}
